var _helper = require('./helper');

/**
 * Username module for the Registration page
 */
module.exports = {

	/**
	 * initialize
	 */	
	init: function(params) {
		var self = this;
		
		self.$el = $('#credential\\.username');
		var $el = self.$el;
		
		self.$resultContainer = $el.siblings('.availability-result-container');		
		self.$suggestions = $('.suggestions', self.$resultContainer);
		self.$messageContainer = $('.availability-message', self.$resultContainer);
		self.$errorIcon = $el.siblings('.text-error-icon');
		self.$verifiedIcon = $el.siblings('.text-verified-icon');
		self.$linkContainer = $('.check-availability-container');
		self.serviceUri = 'user/username';
		
		/* Helper funtion to replace tokens in a String when a data object 
		*  Token names are the keys in the data object 
		*/
		String.prototype.bind = function(data) {
			var s = this.toString();
			for(var key in data) {
				var re = new RegExp('\\{' + key + '\\}', 'gm');
				 s = s.replace(re, data[key]);
			}
			
			return s;
		};

		// when suggestions.changed happens, we need to re-hook 'change' event on those suggestions  
		self.bindSuggestionsChange();		
		
		/* Event listener for hiding or showing the 'Check availability' link */
		self.bindInput(params);
	},
	
	/**
	 * Bind the 'change' event when suggenstions has been populated
	 */
	bindSuggestionsChange: function() {
		var self = this;
		self.$suggestions.on('suggestions.changed', function() {
			$('input[type=radio]', this).on('change', function() {
				self.$el.val($(this).val());
				self.checkUserNameAvailability();
			});
		});	
	},
	
	/* Update the availability result message */
	toggleAvailabilityMessage: function($messageContainer, available) {
		$('.username-taken', $messageContainer).toggleClass('hidden', available);
		$('.username-available', $messageContainer).toggleClass('hidden', !available);
	},
	
	/* Popluate suggetions if there are any */
	buildSuggestions: function($parent, names) {
		
		if(!$.isArray(names) || names.length === 0) {
			return;
		}
		
		/* As of jQuery 1.12, empty() method removes event listeners */
		$parent.empty();
		var tml = "<label for='suggestion-{index}'><input type='radio' name='suggested-usernames' value='{value}' id='suggestion-{index}'><span>{value}</span></label>";
		for(var i = 0; i < names.length; ++i) {
    		var label = tml.bind({
    			index: i,
    			value: names[i]
    		});
    		
    		$parent.append(label);
		}
		
		$parent.trigger('suggestions.changed');
	},
	
	
	/* Check username availability */
	checkUserNameAvailability: function() {
		var self = this, 
			$el = self.$el, 
			$suggestions = self.$suggestions,
			username = $.trim($el.val());
		
		if(username === '') {
			return $.Deferred();
		}
		
		var promise = _helper.ajaxPost(self.serviceUri, {username: username});
		
		promise.then($.proxy(self.handleResult, self));
		
		return promise;
	},
	
	/*
	 * Handle the result of availability checking
	 */
	handleResult: function(data, reloading) {
		var self = this, 
			$el = self.$el, 
			$suggestions = self.$suggestions,
			$errorIcon = self.$errorIcon,
			$verifiedIcon = self.$verifiedIcon;
		
		if(!$.isPlainObject(data)) return;
		
		$el.val(data.username);
		$el.toggleClass('has-error', !data.available);
		$el.toggleClass('verified', data.available);
		self.$resultContainer.removeClass('hidden');
		$errorIcon.toggleClass('hidden', data.available);
		$verifiedIcon.toggleClass('hidden', !data.available);
		if(!data.available) {
			self.buildSuggestions($suggestions, data.suggestions);			
		}else{
			$suggestions.empty();
		}
		self.toggleAvailabilityMessage(self.$messageContainer, data.available);		
	},
		
	/**
	 * Bind input and propertychange to username field
	 */
	bindInput: function(params) {
		var self = this, 
			$el = self.$el;
		
		$el.prop('handled', []);
				
		$el.on(_helper.isIE() ? 'keyup' : 'input' , function(e) {
			var val = $el.val();
			self.handleChange(params.minUsernameLength, val);
		});
		
		self.handleResult(params.availabilityResult, true);
	},
	
	/**
	 * handle the value change on username field
	 */
	handleChange: function(minLength, val) {
		var self = this, $linkContainer = self.$linkContainer;
		
		var hiding = val.length < minLength;
		$linkContainer.toggleClass('hidden', hiding);		
		var link = $('.check-availability');
		link.off();
		if(!hiding) {
			link.on('click', function() {
				self.checkUserNameAvailability();
			});
			_helper.removeValidationErrors(this);
		}
		self.resetField();
	},
	
	/**
	 * reset username field to normal style
	 */
	resetField: function() {
		var self = this, 
			$el = self.$el, 
			$resultContainer = self.$resultContainer, 
			$errorIcon = self.$errorIcon,
			$verifiedIcon = self.$verifiedIcon;
		
		$el.removeClass('has-error');
		$el.removeClass('verified');
		$errorIcon.removeClass('hidden').addClass('hidden');
		$resultContainer.removeClass('hidden').addClass('hidden');
		$verifiedIcon.removeClass('hidden').addClass('hidden');		
	}
	
};


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/registration/username.js
// module id = 254
// module chunks = 4